import { Tooltip } from '@mui/material';
import { AccessAlarm, CheckCircleOutline, ErrorOutline } from '@mui/icons-material';
import { TFunction } from 'react-i18next';

export const getsimulationActivityIcon = (state: string, t: TFunction<"translation", undefined>, userIsValid: boolean = false) => {
  switch (state) {
    case 'ACTIVE':
      return <Tooltip placement='top' arrow title={<>{t('grantedActivityMesage')}</>}>
        <div style={{ cursor: 'pointer' }} data-testid={'rowIcon'}>
          <CheckCircleOutline color='secondary' />
        </div>
      </Tooltip>;
    case 'PENDING':
      return <Tooltip placement='top' arrow title={<>{t('proposalActivityMesage')}</>}>
        <div style={{ cursor: 'pointer' }} data-testid={'rowIcon'}>
          <AccessAlarm color='info' />
        </div>
      </Tooltip>
    case 'REJECTED':
      return <Tooltip placement='top' arrow title={<>{t('proposalNotReachesMinThreshold')}</>}>
        <div style={{ cursor: 'pointer' }} data-testid={'rowIcon'}>
          <ErrorOutline color='error' />
        </div>
      </Tooltip>
    default:
      return <Tooltip placement='top' arrow title={userIsValid ? <>{t('warningActivityMesageWithUseValid')}</> : <>{t('warningActivityMesage')}</>}>
        <div style={{ cursor: 'pointer' }} data-testid={'rowIcon'}>
          <ErrorOutline color='warning' />
        </div>
      </Tooltip>;
  }
}